import React from 'react'
import { useToast } from './ToastProvider'

/**
 * 비-React 코드(axios 인터셉터 등)에서도 토스트를 띄울 수 있도록
 * window.toast.show 를 연결한다.
 *
 * 사용 예:
 *   window.toast?.show?.('메시지', 'error')
 */
export default function GlobalToastBridge() {
  const { show } = useToast()

  React.useEffect(() => {
    const prev = (typeof window !== 'undefined') ? window.toast : undefined
    if (typeof window !== 'undefined') {
      window.toast = {
        show: (message, variant = 'info', timeoutMs = 2500) => show(message, variant, timeoutMs),
      }
    }
    return () => {
      if (typeof window === 'undefined') return
      // 기존 값 복원(다른 브릿지가 있을 수 있어 방어적으로 처리)
      if (prev) window.toast = prev
      else {
        try { delete window.toast } catch { window.toast = undefined }
      }
    }
  }, [show])

  return null
}

